import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';
import IconButton from '@mui/material/IconButton';
import '../styles/Social.css';
import instagram from '../assets/instgram.png'
import twitter from '../assets/twitter2.png'
import discord from '../assets/discord.png'
export default function Socails() {
  return (
    <div className='socail_container'>
        <a href="https://www.instagram.com/brewing_banner_project/"><IconButton>
            <img src={instagram}/>
          </IconButton></a>
        <a href="https://twitter.com/Brewing_Banner"><IconButton><img src={twitter}/></IconButton></a>
        <a href=""></a><IconButton><img src={discord}/></IconButton>
    </div>
  )
}
